import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgMenuOpen = (props: SVGProps) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 14" fill="none" {...props}>
      <path stroke="currentColor" strokeWidth={2} d="M0 1h20M0 7h20M0 13h20" />
    </svg>
  );
};

export default SvgMenuOpen;
